import React, { ReactElement } from 'react';
import { Row, Col, Typography } from 'antd';
import Panel from '../../../shared/components/card/Panel';
import { GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';

const { Title, Text } = Typography;

const DetailsCard = (props: any): ReactElement => {
  const { detail } = props || {};
  const appDetail = ApplicationDetail.instance;
  return (
    <Panel className="cardclass">
      <Row gutter={GUTTOR_SPACE}>
        <Col span={24}>
          <strong className="fsize_lg">
            <Text type="secondary">Patient Name</Text>
            <Text className="ml-5">{detail?.patientName}</Text>
          </strong>
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE} className="mt-sm">
        <Col md={24}>
          <Title level={5}>{appDetail.getProviderName()}</Title>
        </Col>
      </Row>
    </Panel>
  );
};
export default DetailsCard;
